<template>
  <div>
    <div class="feedback_top_bar">
      <span class="feedback_tip feedback_tip_noac" @click="goTome">
        个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="feedback_tip">反馈</span>
    </div>

    <div class="feedback_bgcon">
      <div class="feedback_tp_con">
        <div class="feedback_tp_item">具体反馈内容</div>
      </div>
      <div>
         <textarea class="fb_con" v-model="feedbackContent" placeholder="请在这里输入内容"></textarea>
      </div>
    </div>

    <div class="feedback_btns_con">
      <button class="feedback_share_btn" @click="submitFeedback">提 交</button>
    </div>
  </div>
</template>

<script>
import { addFeedback } from "@/api/feedback.js";
export default {
  name: "feedback",
  data() {
    return {
      stimeval: "",
      ctimeval: "",
      tpList: ["我分享的", "我收到的"],
      curSes: 0,
      shareList: [1, 2, 3],
      feedbackContent: "", // Added to hold the textarea content
    };
  },
  mounted() {},
  methods: {
    goTome() {
      this.$router.push({ name: "me" });
    },
    tpses(index) {
      this.curSes = index;
    },
    detail() {
      var that = this;

      that.$router.push({ name: "artdetail", params: { refresh: true } });
    },
    share() {
      var that = this;

      that.$router.push({ name: "feedback", params: { refresh: true } });
    },
    submitFeedback() {
      // 获取当前时间作为反馈提交时间
      const now = new Date();
      const formattedTime = now.toISOString().slice(0, 19).replace("T", " ");

      const feedbackData = {
        content: this.feedbackContent, // 从textarea获取的用户输入
        time: formattedTime, // 使用当前时间，格式为 YYYY-MM-DD HH:MM:SS
      };

      addFeedback(feedbackData)
        .then((response) => {
          // 处理成功响应
          this.$message.success("反馈成功");
          this.feedbackContent = ""; // 提交成功后清空表单
        })
        .catch((error) => {
          // 处理错误响应
          console.error("Submission failed:", error);
          this.$message.error("反馈失败");
        });
    },
  },
};
</script>

<style>
.feedback_share_btn {
  background-image: url("../assets/yulan.png");
  width: 165px;
  height: 50px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 15px;
  color: #fff6d5;
  border: none;
  cursor: pointer;
  font-size: 18px;
}

.feedback_btns_con {
  margin-top: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fb_con {
  width: 100%;
  height: 300px;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /*Firefox*/
  -webkit-box-sizing: border-box; /*Safari*/
  padding: 10px;
  font-size: 16px;
}

.feedback_tp_item {
  color: #262626;
  font-size: 18px;
  font-weight: 550;
  margin-right: 20px;
  cursor: pointer;
  padding-bottom: 4px;
}

.feedback_tp_con {
  display: flex;
  align-items: center;
  background-color: #dedede;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: solid 1px #cccccc;
}

.feedback_bgcon {
  margin-top: 30px;
  border: solid 1px #dedede;
}

.feedback_txt_label {
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.feedback_line_con {
  display: flex;
  align-items: center;
}

.feedback_tip_noac {
  color: #cccccc !important;
}

.feedback_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.feedback_top_bar {
  display: flex;
  align-items: center;
}
</style>
